import { render, staticRenderFns } from "./MenuSmall.vue?vue&type=template&id=5844c8ad&"
import script from "./MenuSmall.vue?vue&type=script&lang=js&"
export * from "./MenuSmall.vue?vue&type=script&lang=js&"
import style0 from "./MenuSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports